module.exports = __webpack_public_path__ + "static/images/speaker.48073ff822a6a6db42ba38057a9b05fe.svg";